'use client';

import { SavingsPlanStatus } from '@bts-web/data-layer/server';
import { PillBar } from '../../common';
import { SavingsPlansListTranslationsKeys } from '../types';
import { useSavingsPlansContext } from '../SavingsPlansContext/SavingsPlansContext.use-client';

interface SavingsPlansFilterBarProps {
  canceledSavingsPlansCount: number;
  translations: Pick<
    SavingsPlansListTranslationsKeys,
    'savingsPlansListActive' | 'savingsPlansListCancelled' | 'all'
  >;
}

const SavingsPlansFilterBar = ({
  translations,
  canceledSavingsPlansCount,
}: SavingsPlansFilterBarProps) => {
  const { status, setCurrentStatus, isLoading } = useSavingsPlansContext();

  let filterItems = [
    {
      label: translations.all,
      value: 'All',
    },
    {
      label: translations.savingsPlansListActive,
      value: 'ACTIVE',
    },
  ];

  if (canceledSavingsPlansCount > 0) {
    filterItems = [
      ...filterItems,
      {
        label: translations.savingsPlansListCancelled,
        value: 'CANCELED',
      },
    ];
  }

  return (
    <PillBar
      disabled={isLoading}
      onValueChange={(value) => {
        setCurrentStatus(value as SavingsPlanStatus);
      }}
      value={status}
      items={filterItems}
    />
  );
};

export { SavingsPlansFilterBar };
